var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-1"},[(!_vm.v2)?_c('div',{staticClass:"w-full"},[_c('FuseMultiselect',{attrs:{"placeholder":"Select Assets","data":_vm.dataSource,"multiple":!_vm.singleSelect,"fields":_vm.f,"value":_vm.value},on:{"input":(v) => _vm.$emit('input', v)}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }